// extracted by mini-css-extract-plugin
export var divider = "_et-7";
export var itemsToggle = "_et-8";
export var mergeModal = "_et-1";
export var optionCard = "_et-4";
export var radioGroup = "_et-6";
export var radioOption = "_et-0";
export var selected = "_et-5";
export var shipmentOptions = "_et-2";
export var tableOptions = "_et-3";